import React from 'react';
import TextInputField from '../Clinic/InputFields/TextInputField';
import CheckboxInputField from '../Clinic/InputFields/CheckboxInputField';
import RadioInputField from '../Clinic/InputFields/RadioInputField';
import DropdownInputField from '../Clinic/InputFields/DropdownInputField';
import EmailInputField from '../Clinic/InputFields/EmailInputField';
import DuedateInputField from '../Clinic/InputFields/DuedateInputField';
import MobileInputField from '../Clinic/InputFields/MobileInputField';

export default function formField(props) {
  const { inputFieldErrorHandler, questions } = props;
  return (
    <div>
      {questions?.map((element, index) => {
        switch (element?.type) {
          case '1':
            return (
              <TextInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );

          case '2':
            return (
              <CheckboxInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );

          case '3':
            return (
              <RadioInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );
          case '4':
            return (
              <DropdownInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );
          case '5':
            return (
              <EmailInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );

          case '6':
            return (
              <DuedateInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );
          case '7':
            return (
              <MobileInputField
                element={element}
                index={index}
                inputFieldErrorHandler={inputFieldErrorHandler}
                key={`form_${index}`}
              />
            );

          default:
            break;
        }
      })}
    </div>
  );
}
